const getColor = (formComponents, checkboxLabel, hasError, dark, warning) => {
  if (checkboxLabel) {
    return dark ? formComponents.dark.color : formComponents.checkboxLabel.color;
  }

  if (hasError) {
    return dark
      ? warning ? formComponents.dark.warning.color : formComponents.dark.error.color
      : warning ? formComponents.warning.color : formComponents.error.color;
  }

  return dark ? formComponents.dark.color : formComponents.label.color;
};

export default ({ formComponents }) => ({
  root: ({
    checkboxLabel, hasError, dark, textarea, inline, warning
  }) => ({
    ...(checkboxLabel ? formComponents.checkboxLabel : formComponents.label),
    color: getColor(formComponents, checkboxLabel, hasError, dark, warning),
    lineHeight: (() => {
      if (inline) {
        const pixels = textarea
          ? formComponents.input.textareaHeight
          : formComponents.input.height;
        return `${pixels}px`;
      }
      return undefined;
    })()
  }),
  optional: {
    float: 'right',
    marginRight: -5
  }
});
